query GetContactEnrichment($input: ContactEnrichmentInput!) {
    contactEnrichment(input: $input) {
        baseFields {
            label
            displayLabel
            value
            isNew
        }
        companyFields {
            label
            displayLabel
            value
            isNew
        }
        socialFields {
            label
            displayLabel
            value
            isNew
        }
    }
}
